import gql from 'graphql-tag'

export default gql`mutation updateEditClient($data: ClientInput) {
    updateEditClient(data: $data) @client
}`